import React, { useEffect, useState } from 'react';
import Overview from './Overview';
import AccountsSummary from './accounts/AccountsSummary'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import Charts from "./positions/Charts"
import BonusTradesOverview from './trades/BonusTradesOverview';
import StockResearch from './stock/StockResearch';
import TradeNotes from './trades/TradeNotes';

function Home(props) {

    let { activeTab } = useParams();

    const [tab, setTab] = useState(activeTab ? activeTab : 'overview');
    const [account, setAccount] = useState(null);

    function shouldAllow() {
        return true;
    }

    const handleChangeTab = (event, newTab) => {
        setTab(newTab);
    };

    useEffect(() => {
        async function loadAccounts() {
            if (props.accountId && props.userId) {
                const response = await fetch(`/api/accounts?userId=${props.userId}`)
                if (response.ok) {
                    const text = await response.json()
                    let account = text.find(act => act.idaccounts === Number(props.accountId));
                    if (account)
                        console.log("Home Account", props.accountId, account);
                    else {
                        console.log("Could not find account", props.accountId, text);
                    }
                    setAccount(account)
                }
            }
        }
        loadAccounts()
    }, [props.userId, props.accountId]);

    return (
        <div>
            {shouldAllow() ?
                <>
                    <Box sx={{ bgcolor: '#F0F0F0', border: 1, borderBottom: 0, borderColor: 'black', borderRadius: 0 }}>
                        <Tabs
                            value={tab}
                            onChange={handleChangeTab}
                            textColor="secondary"
                            indicatorColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab value="overview" label="Overview" />
                            <Tab value="accounts" label="Accounts Summary" />
                            <Tab value="bonus" label="Bonus Trades" />
                            <Tab value="charts" label="Charts" />
                            <Tab value="megachart" label="Mega Chart" />
                            <Tab value="notes" label="Trade Notes" />
                        </Tabs>
                    </Box>
                    <br></br>

                    {tab === "overview" ?
                        <>
                            <Overview accountId={props.accountId} isOptions={props.isOptions} accountStartDate={props.accountStartDate} planId={props.planId} accountValue={props.accountValue} userId={props.userId}
                                mobileView={props.mobileView}
                                brokerage={account ? account.brokerage : undefined}
                                brokerageHref={account ? account.brokerage_href : undefined}
                                brokerageAuthenticated={account ? account.access_token && account.access_token.length > 0 : undefined}
                                hideAccountValues={props.hideAccountValues}
                                role={props.role}
                            />
                        </>
                        : null}
                    {tab === "accounts" ?
                        <>
                            <AccountsSummary onAccountSelected={props.onAccountSelected} mobileView={props.mobileView} accountId={props.accountId} userId={props.userId} onAccountsUpdated={props.onAccountsUpdated} hideAccountValues={props.hideAccountValues} />
                        </>
                        : null}

                    {tab === "notes" ?
                        <>
                            <TradeNotes userId={props.userId} planId={props.planId} accountId={props.accountId} role={props.role} mobileView={props.mobileView} />
                        </>
                        : null}
                    {tab === "bonus" ?
                        <>
                            <BonusTradesOverview brokerageConnections={account && account.brokerage ? [account.brokerage] : null} mobileView={props.mobileView} userId={props.userId} accountValue={props.accountValue} accountId={props.accountId} onAlgoSelected={props.onAlgoSelected} role={props.role} />
                        </>
                        : null}
                    {tab === "charts" ?
                        <>
                            <Charts mobileView={props.mobileView} planId={props.planId} userId={props.userId} accountId={props.accountId} />
                        </>
                        : null}
                    {tab === "megachart" ?
                        <>
                            <StockResearch mobileView={props.mobileView} planId={props.planId} userId={props.userId} accountId={props.accountId} />
                        </>
                        : null}
                </>
                :
                <div class="empty-page" >Not allowed</div>
            }


        </div>
    );
}

export default Home;